import React from 'react';

function Icon(props) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="78" height="78" viewBox="0 0 78 78" {...props}>
      <defs>
        <clipPath id="clip-path">
          <path
            fill={props.fillPrimary}
            stroke="#707070"
            strokeWidth="1"
            d="M0 0H53V26H0z"
            data-name="Rectangle 994"
            transform="translate(-.423 .352)"></path>
        </clipPath>
        <clipPath id="clip-Raider">
          <path d="M0 0H78V78H0z"></path>
        </clipPath>
      </defs>
      <g clipPath="url(#clip-Raider)">
        <g data-name="Group 2745" transform="translate(5.973 20.648)">
          <g clipPath="url(#clip-path)" data-name="Mask Group 33" transform="translate(7.451)">
            <g data-name="Group 2740" transform="translate(8.536 -.191)">
              <g data-name="Group 2738">
                <circle
                  cx="4.104"
                  cy="4.104"
                  r="4.104"
                  fill={props.fillPrimary}
                  data-name="Ellipse 467"></circle>
                <path
                  fill="none"
                  stroke={props.fillPrimary}
                  strokeMiterlimit="10"
                  strokeWidth="0.208"
                  d="M5.419 13.071l3.661-3.9a1.872 1.872 0 012.593-.114 1.626 1.626 0 01.071 2.188l-3.8 3.9"
                  data-name="Path 5666"></path>
                <path
                  fill={props.fillPrimary}
                  d="M549.086 463.956s5.874.5 5.686-5.624l16.435-.313a1.472 1.472 0 011.729 1.521 1.6 1.6 0 01-1.729 1.729l-11.962.373 5.651 3.251 16.372-2.375 5.249-.562a2.155 2.155 0 012.207 1.812 1.961 1.961 0 01-1.416 2.333l-13.622 2.271-4.292.708-4.124 2.12-1.437 5.874-1.062 15.56a2.115 2.115 0 01-2.27 2.062c-2.312.125-2.229-2.437-2.229-2.437l1.125-18.81-5.13-3.18s-2.307 2.681-3.807 3.18a1.4 1.4 0 01-1.564-.547 5.707 5.707 0 01-.685-2.514c-.12-1.851.036-6.097.875-6.432zm2.3 3.743l-.032.671a.077.077 0 00.127.062l.444-.465a.077.077 0 00-.013-.126l-.411-.206a.078.078 0 00-.111.065z"
                  data-name="Path 5667"
                  transform="translate(-546.035 -455.313)"></path>
              </g>
              <g data-name="Group 2739" transform="translate(5.834 8.474)">
                <path
                  fill={props.fillPrimary}
                  d="M554.994 471.5a.085.085 0 01-.059-.023.086.086 0 010-.123l3.51-3.712a1.523 1.523 0 00-.065-2.067 1.542 1.542 0 00-1.683-.371 2.427 2.427 0 00-.79.485l-3.158 3.408a.087.087 0 11-.127-.118l3.16-3.411a1.966 1.966 0 012.716-.119 1.718 1.718 0 01.079 2.3v.005l-3.514 3.715a.087.087 0 01-.069.031z"
                  data-name="Path 5668"
                  transform="translate(-552.596 -464.924)"></path>
              </g>
            </g>
          </g>
          <g data-name="Group 2743" transform="translate(11.921 28.292)">
            <rect
              width="43"
              height="16"
              fill={props.fillPrimary}
              data-name="Rectangle 918"
              rx="8"
              transform="translate(.106 .059)"></rect>
            <text
              fill={props.fillSecondary}
              fontFamily="ProximaNova-Bold, Proxima Nova"
              fontSize="15"
              fontWeight="700"
              transform="translate(22.106 13.059)">
              <tspan x="-12.008" y="0">
                RAI
              </tspan>
            </text>
          </g>
        </g>
      </g>
    </svg>
  );
}

export default Icon;
